import React, { useEffect, useState } from 'react';
import { getWeatherIconClass, getWindIconClass } from '../utils/weatherIconMapper';
import 'weather-icons/css/weather-icons.min.css';

const HourlyForecast = ({ forecast }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  
  // Debug log to show hourly forecast conditions
  useEffect(() => {
    if (forecast && forecast.length > 0) {
      console.log('Hourly forecast conditions:', forecast.map(hour => ({
        time: hour.time,
        condition: hour.condition,
        isDay: hour.isDay,
        iconClass: getWeatherIconClass(hour.condition, hour.isDay)
      })));
    }
  }, [forecast]);
  
  // Toggle expanded row
  const toggleExpandedRow = (index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
    }
  };

  // If no forecast data is available, show a message
  if (!forecast || forecast.length === 0) {
    return (
      <div className="tab-content hourly-tab">
        {/* <h3 className="hourly-heading">Next 12 Hours</h3> */}
        <p className="no-data-message">Hourly forecast data not available</p>
      </div>
    );
  }

  return (
    <div className="tab-content hourly-tab">
      {/* å<h3 className="hourly-heading">Next 12 Hours</h3> */}
      <table className="hourly-forecast-table">
        <thead>
          <tr>
            <th>Time</th>
            <th>Temp</th>
            <th>Wind</th>
            <th>Precip</th>
            <th></th> {/* Empty header for detail buttons */}
          </tr>
        </thead>
        <tbody>
          {forecast.map((hour, index) => {
            const weatherIconClass = getWeatherIconClass(hour.condition, hour.isDay);
            const windIconClass = getWindIconClass(hour.windSpeed, hour.windDirection);
            
            return (
              <React.Fragment key={index}>
                <tr 
                  className={expandedRow === index ? 'expanded-row' : ''}
                  onClick={() => toggleExpandedRow(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{hour.time}</td>
                  <td className="hourly-temp">
                    <i className={`wi ${weatherIconClass} weather-icon hourly-icon`}></i>
                    <strong>{hour.temperature}°</strong>
                  </td>
                  <td className="hourly-wind">
                    <i className={windIconClass}></i>
                    {hour.windSpeed} mph
                  </td>
                  <td className="hourly-precip">
                    <i className="wi wi-raindrop"></i>
                    {hour.precipitation}
                  </td>
                  <td className="detail-btn">
                    <button 
                      className={`detail-circle ${expandedRow === index ? 'expanded' : ''}`} 
                      aria-label="More details"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleExpandedRow(index);
                      }}
                    >
                      <i className="wi wi-direction-right"></i>
                      <span className="sr-only">Show details</span>
                    </button>
                  </td>
                </tr>
                {expandedRow === index && (
                  <tr className="details-row">
                    <td colSpan="5">
                      <div className="hourly-details">
                        <div className="hourly-time-temp">
                          {/* <span className="hourly-time">{hour.time}</span> */}
                          <span className="hourly-temp-detail">
                            <i className={`wi ${weatherIconClass} weather-icon hourly-icon`}></i>
                            <strong>{hour.temperature}°</strong>
                          </span>
                          <span className="hourly-condition-name">{hour.condition}</span>
                        </div>
                        <div className="hourly-details-right-section">
                        <div className="hourly-details-grid">
                            <div className="hourly-detail-left">
                                <div className="detail-item-row">
                                <span className="detail-item-label">Wind:</span>
                                <span className="detail-item-value">
                                    <i className={windIconClass}></i>
                                    {hour.windDirection ? `${hour.windDirection} @ ${hour.windSpeed} mph` : `${hour.windSpeed} mph`}
                                </span>
                                </div>
                                <div className="detail-item-row">
                                <span className="detail-item-label">Humidity:</span>
                                <span className="detail-item-value">
                                    <i className="wi wi-humidity"></i>
                                    {hour.humidity}
                                </span>
                                </div>
                                <div className="detail-item-row">
                                <span className="detail-item-label">Heat Index:</span>
                                <span className="detail-item-value">
                                    <i className="wi wi-thermometer"></i>
                                    {hour.heatIndex}°
                                </span>
                                </div>
                                {/* dew point */}
                                <div className="detail-item-row">
                                    <span className="detail-item-label">Dew Point:</span>
                                    <span className="detail-item-value">
                                        <i className="wi wi-thermometer-exterior"></i>
                                        {hour.dewPoint}°
                                    </span>
                                </div>
                            </div>
                            
                            <div className="hourly-detail-right">
                                <div className="detail-item-row">
                                <span className="detail-item-label">Precip:</span>
                                <span className="detail-item-value">
                                    <i className="wi wi-raindrop"></i>
                                    {hour.precipitation} Chance
                                </span>
                                </div>
                                <div className="detail-item-row">
                                <span className="detail-item-label">Wind Chill:</span>
                                <span className="detail-item-value">
                                    <i className="wi wi-thermometer-exterior"></i>
                                    {hour.windChill}°
                                </span>
                                </div>
                                <div className="detail-item-row">
                                <span className="detail-item-label">Visibility:</span>
                                <span className="detail-item-value">
                                    <i className="wi wi-dust"></i>
                                    {hour.visibility}
                                </span>
                                </div>
                            
                                <div className="detail-item-row">
                                    <span className="detail-item-label">UV Index:</span>
                                    <span className="detail-item-value">
                                        <i className="wi wi-day-sunny"></i>
                                        {hour.uvIndex}
                                    </span>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default HourlyForecast; 